import { BlastEvent, SimulationConfig } from '@/types';
import { getRadiusAtAngle } from '@/logic/break/BreakUtils';
import { registerBlastAnimation } from './BlastAnimationRegistry';

export const GlitchSquareAnimation = (
  ctx: CanvasRenderingContext2D,
  e: BlastEvent,
  config: SimulationConfig,
  progress: number
) => {
  const sz = 20 * (1 - progress);
  for(let i=0; i<12; i++){
    const angle = (i / 12) * Math.PI * 2;
    const dist = e.maxRadius + (Math.random() - 0.5) * 50;
    const r = getRadiusAtAngle(angle, e, dist);
    const ox = Math.cos(angle) * r;
    const oy = Math.sin(angle) * r;
    ctx.strokeRect(e.pos.x + ox - sz/2, e.pos.y + oy - sz/2, sz, sz);
  }
};

registerBlastAnimation('GLITCH_SQUARE', GlitchSquareAnimation);
